(function () {
  'use strict';

  var EXCLUDE = [
    '.article__content',
    '.article-content',
    '.product-description',
    '[data-product-description]'
  ];

  function isExcluded(el) {
    return EXCLUDE.some(function (sel) { return !!el.closest(sel); });
  }

  function getSettings(el) {
    var wrapper = el.closest('[id^="shopify-section-"]');
    if (!wrapper) return null;
    var carrier = wrapper.querySelector('.hl-carrier');
    if (!carrier) return null;
    var type = carrier.dataset.hlType;
    if (!type || type === 'none') return null;
    return {
      type:     type,
      scribble: carrier.dataset.hlScribble || 'underline',
      color:    carrier.dataset.hlColor    || '#e8a87c',
      stroke:   parseFloat(carrier.dataset.hlStroke) || 3,
      reveal:   carrier.dataset.hlReveal !== 'false'
    };
  }

  function processAll(root) {
    root = root || document;
    root.querySelectorAll('main em, main i').forEach(function (el) {
      if (isExcluded(el)) return;
      if (el.dataset.hlInit) return;
      var s = getSettings(el);
      if (!s) return;
      el.dataset.hlInit = '1';

      if (s.type === 'scribble') {
        setupScribble(el, s);
      } else {
        setupCSS(el, s);
      }
    });
  }

  /* ── CSS effects ──────────────────────────────────────────── */

  function setupCSS(el, s) {
    el.classList.add('hl-applied');
    el.style.setProperty('--hl-color', s.color);
    el.classList.add('hl-' + s.type);

    // Underlines have no reveal animation — just show
    if (s.type === 'normal-underline' || s.type === 'fancy-underline' || !s.reveal) {
      el.classList.add('hl-no-reveal');
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        // Double rAF: ensures browser has painted initial state before transition
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            entry.target.classList.add('hl-active');
          });
        });
      });
    }, { threshold: 0.2 });

    obs.observe(el);
  }

  /* ── SVG scribble effects ─────────────────────────────────── */

  function setupScribble(el, s) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        drawScribble(entry.target, s);
      });
    }, { threshold: 0.2 });
    obs.observe(el);
  }

  function drawScribble(el, s) {
    if (window.getComputedStyle(el).position === 'static') {
      el.style.position = 'relative';
    }
    var rect = el.getBoundingClientRect();
    var w = rect.width;
    var h = rect.height;
    if (w < 4) return;

    var svg = buildSVG(s.scribble, w, h, s.color, s.stroke);
    if (!svg) return;
    el.appendChild(svg);

    if (!s.reveal) return; // show immediately, no stroke animation

    requestAnimationFrame(function () {
      svg.querySelectorAll('path').forEach(function (path) {
        var len = path.getTotalLength();
        path.style.strokeDasharray  = len;
        path.style.strokeDashoffset = len;
        path.getBoundingClientRect(); // force reflow
        path.style.transition = 'stroke-dashoffset 0.75s cubic-bezier(0.4,0,0.2,1)';
        path.style.strokeDashoffset = '0';
      });
    });
  }

  /* ── SVG path builder ─────────────────────────────────────── */

  function buildSVG(style, w, h, color, stroke) {
    var ns  = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable',   'false');
    svg.style.position      = 'absolute';
    svg.style.pointerEvents = 'none';
    svg.style.overflow      = 'visible';

    var d, svgW, svgH, left, top;

    switch (style) {

      case 'underline': {
        svgW = w;
        svgH = stroke * 2 + 2;
        left = 0;
        top  = h + 3;
        d    = 'M 2 ' + (svgH / 2) + ' L ' + (svgW - 2) + ' ' + (svgH / 2);
        break;
      }

      case 'circle': {
        var padX = Math.max(8, w * 0.05);
        var padY = Math.max(5, h * 0.15);
        var rx   = w / 2 + padX;
        var ry   = h / 2 + padY;
        svgW = w + padX * 2;
        svgH = h + padY * 2;
        left = -padX;
        top  = -padY;
        var cx = svgW / 2;
        var cy = svgH / 2;
        var K  = 0.5523;
        var ox = rx * K;
        var oy = ry * K;
        d  = 'M ' + (cx + rx) + ' ' + cy;
        d += ' C ' + (cx + rx) + ' ' + (cy - oy) + ',' + (cx + ox) + ' ' + (cy - ry) + ',' + cx + ' ' + (cy - ry);
        d += ' C ' + (cx - ox) + ' ' + (cy - ry) + ',' + (cx - rx) + ' ' + (cy - oy) + ',' + (cx - rx) + ' ' + cy;
        d += ' C ' + (cx - rx) + ' ' + (cy + oy) + ',' + (cx - ox) + ' ' + (cy + ry) + ',' + cx + ' ' + (cy + ry);
        d += ' C ' + (cx + ox) + ' ' + (cy + ry) + ',' + (cx + rx) + ' ' + (cy + oy) + ',' + (cx + rx) + ' ' + cy;
        break;
      }

      case 'sketch': {
        svgW = w + 6;
        svgH = 14;
        left = -3;
        top  = h + 2;
        d  = 'M 1 ' + (svgH * 0.55);
        d += ' C ' + (svgW * 0.22) + ' ' + (svgH * 0.08);
        d += ' '   + (svgW * 0.52) + ' ' + (svgH * 0.92);
        d += ' '   + (svgW - 1)    + ' ' + (svgH * 0.42);
        break;
      }

      case 'fancy1': {
        svgW = w + 8;
        svgH = 16;
        left = -4;
        top  = h + 1;
        var waves = Math.max(2, Math.round(svgW / 28));
        var seg   = svgW / waves;
        d = 'M 0 ' + (svgH / 2);
        for (var i = 0; i < waves; i++) {
          var x0   = i * seg;
          var xMid = x0 + seg / 2;
          var xEnd = x0 + seg;
          d += ' C ' + (x0   + seg * 0.18) + ' ' + (svgH * 0.04);
          d += ' '   + (xMid - seg * 0.18) + ' ' + (svgH * 0.04);
          d += ' '   + xMid + ' ' + (svgH / 2);
          d += ' C ' + (xMid + seg * 0.18) + ' ' + (svgH * 0.96);
          d += ' '   + (xEnd - seg * 0.18) + ' ' + (svgH * 0.96);
          d += ' '   + xEnd + ' ' + (svgH / 2);
        }
        break;
      }

      case 'fancy2': {
        svgW = w + 6;
        svgH = 12;
        left = -3;
        top  = h + 1;
        var steps = Math.max(4, Math.round(svgW / 14));
        var sw    = svgW / steps;
        d = 'M 0 ' + (svgH / 2);
        for (var j = 0; j < steps; j++) {
          var xCtrl = j * sw + sw / 2;
          var xTo   = (j + 1) * sw;
          var yCtrl = j % 2 === 0 ? svgH * 0.04 : svgH * 0.96;
          d += ' Q ' + xCtrl + ' ' + yCtrl + ' ' + xTo + ' ' + (svgH / 2);
        }
        break;
      }

      default:
        return null;
    }

    svg.setAttribute('width',  svgW);
    svg.setAttribute('height', svgH);
    svg.style.left = left + 'px';
    svg.style.top  = top  + 'px';

    var path = document.createElementNS(ns, 'path');
    path.setAttribute('d',               d);
    path.setAttribute('stroke',          color);
    path.setAttribute('stroke-width',    stroke);
    path.setAttribute('stroke-linecap',  'round');
    path.setAttribute('stroke-linejoin', 'round');
    path.setAttribute('fill',            'none');
    svg.appendChild(path);

    return svg;
  }

  /* ── Init ─────────────────────────────────────────────────── */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { processAll(); });
  } else {
    processAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (section) {
      section.querySelectorAll('[data-hl-init]').forEach(function (el) {
        // Remove effect classes so the section can be re-processed
        el.classList.remove(
          'hl-applied', 'hl-active', 'hl-no-reveal',
          'hl-text-color', 'hl-text-bg', 'hl-normal-underline',
          'hl-fancy-underline', 'hl-marker', 'hl-stencil'
        );
        el.querySelectorAll('svg').forEach(function (s) { s.remove(); });
        delete el.dataset.hlInit;
      });
    }
    processAll();
  });

})();
